// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3AxUE","logo":"logo__3szyq","rightMenu":"rightMenu__17G5g","rightMenu_item":"rightMenu_item__1CDEZ","rightMenu_item_link":"rightMenu_item_link__1bUSR"};


//////////////////
// WEBPACK FOOTER
// ./components/Header/Header.scss
// module id = ZNA0
// module chunks = 0